import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

const STATUS_ORDER = ['Submitted', 'In Progress', 'Not Started'];

const STATUS_VARIANTS = {
  Submitted: 'success',
  'In Progress': 'warning',
  'Not Started': 'secondary',
};

const RankingsSummary = ({
  visibleReportData,
  reportStatuses,
  statusesLoading = false,
}) => {
  const statusSummary = useMemo(() => {
    const counts = {};
    STATUS_ORDER.forEach((s) => {
      counts[s] = 0;
    });

    visibleReportData.forEach((committee) => {
      const committeeId = Number(
        committee.sectionalCommitteeId || committee.id,
      );
      const fallback = statusesLoading ? null : 'Not Started';
      const label = reportStatuses[committeeId]?.label || fallback;
      if (label === null) return;
      if (counts[label] !== undefined) {
        counts[label] += 1;
      } else {
        counts[label] = 1;
      }
    });

    return counts;
  }, [visibleReportData, reportStatuses, statusesLoading]);

  const total = visibleReportData.length;

  return (
    <div className="d-flex align-items-center gap-3 mb-4 p-3 bg-light rounded border">
      <span className="text-muted me-2">
        <strong>Report Status Overview</strong> — {total} committee
        {total !== 1 ? 's' : ''}
      </span>
      {STATUS_ORDER.map((label) => {
        const count = statusSummary[label] ?? 0;
        const variant = STATUS_VARIANTS[label] || 'secondary';
        return (
          <span
            key={label}
            className={`badge border border-${variant} text-${variant} fs-6 px-3 py-2 bg-white`}
          >
            {label}: {count}
          </span>
        );
      })}
    </div>
  );
};

RankingsSummary.propTypes = {
  visibleReportData: PropTypes.array.isRequired,
  reportStatuses: PropTypes.object.isRequired,
  statusesLoading: PropTypes.bool,
};

export default RankingsSummary;
